var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "158",
        height: "112",
        viewBox: "0 0 158 112",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M71.2228 34.4033L-2.28882e-05 34.4033L11.1391 49.593V106.639L14.5146 111.364H67.8473L71.2228 106.639V34.4033Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "49.2821",
          height: "46.5817",
          transform: "matrix(-1 0 0 1 65.8243 60.7324)",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "10.1265",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 45.2051)",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "10.1265",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 79.6348)",
          stroke: "white",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "10.1265",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 97.1875)",
          stroke: "white",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "5.40078",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 53.3066)",
          stroke: "black",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "5.40078",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 70.8594)",
          stroke: "white",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-1",
          x2: "5.40078",
          y2: "-1",
          transform: "matrix(-1 0 0 1 65.8243 88.4111)",
          stroke: "white",
          "stroke-width": "2"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          y1: "-2",
          x2: "101.832",
          y2: "-2",
          transform:
            "matrix(-0.318216 -0.948018 -0.948018 0.318216 46.2462 98.5381)",
          stroke: "black",
          "stroke-width": "4"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M129.262 69.6328L100.524 104.656L102.846 110.999H129.262L129.262 69.6328Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M129.262 69.6328L158 104.656L155.678 110.999H129.262L129.262 69.6328Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "11.0229",
          height: "40.9422",
          transform: "matrix(-1 0 0 1 135.168 58.2461)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          width: "15.747",
          height: "4.7241",
          transform: "matrix(-1 0 0 1 137.527 54.3096)",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_183_9736",
            maskUnits: "userSpaceOnUse",
            x: "100",
            y: "69",
            width: "59",
            height: "42"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M158 104.656L129.262 69.6328L100.524 104.656L102.845 110.999H129.262H155.678L158 104.656Z",
              fill: "#EEA71F"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_183_9736)" } }, [
        _c("rect", {
          attrs: {
            width: "64",
            height: "32",
            transform: "matrix(-1 0 0 1 158 88.999)",
            fill: "black"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }